import "./Nav.scss";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "./../Assets/Images/logo.png";
import fontawesome from "@fortawesome/fontawesome";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const GUIDE_LINKS = [
  {
    label: "Android",
    href: "https://bayun.gitbook.io/bayuncoresdk-android",
  },
  {
    label: "C++",
    href: "https://bayun.gitbook.io/bayuncoresdk-cpp",
  },
  {
    label: "iOS",
    href: "https://bayun.gitbook.io/bayuncoresdk-ios",
  },
  {
    label: "JavaScript",
    href: "https://bayun.gitbook.io/bayuncoresdk-javascript-programming-guide",
  },
  {
    label: "JavaScript AWSS3 Wrapper",
    href: "https://bayun.gitbook.io/bayun-awss3-wrapper-javascript-programming-guide",
  },
  {
    label: "iOS AWSS3 Wrapper",
    href: "https://bayun.gitbook.io/bayun-awss3-wrapper-ios-programming-guide",
  },
  {
    label: "Android AWSS3 Wrapper",
    href: "https://bayun.gitbook.io/bayun-awss3-wrapper-android-programming-guide",
  },
];

const Nav = () => {
  fontawesome.library.add(faChevronDown, faChevronRight);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const resourcesRef = useRef(null);

  useEffect(() => {
    if (!resourcesOpen) return undefined;

    const handlePointerDown = (event) => {
      if (
        resourcesRef.current &&
        !resourcesRef.current.contains(event.target)
      ) {
        setResourcesOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setResourcesOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [resourcesOpen]);

  return (
    <nav className="top-nav">
      <Link to="/" className="nav-logo" aria-label="Bayun home">
        <img src={logo} alt="Bayun Logo" />
      </Link>

      <div className="contact-info">
        <div>contact@bayunsystems.com</div>
        <div>+1-650-450-9951</div>
      </div>

      <div className="right-buttons">
        <div
          className={`resource-container${resourcesOpen ? " open" : ""}`}
          ref={resourcesRef}
        >
          <button
            type="button"
            className="nav-btn nav-btn--resources"
            aria-expanded={resourcesOpen}
            aria-haspopup="true"
            onClick={() => setResourcesOpen((open) => !open)}
          >
            Resources
            <FontAwesomeIcon icon="chevron-down" className="nav-btn__chevron" />
          </button>

          <ul className="resource-list" role="menu">
            <li role="none">
              <a
                href="https://github.com/bayunsystems/BayunSDK"
                target="_blank"
                rel="noopener noreferrer"
                role="menuitem"
              >
                GitHub
              </a>
            </li>
            <li className="guide-menu" role="none">
              <span className="guide-menu__label">
                Developer Guide
                <FontAwesomeIcon
                  icon="chevron-right"
                  className="guide-menu__chevron"
                />
              </span>
              <ul className="resource-sublist" role="menu">
                {GUIDE_LINKS.map((link) => (
                  <li key={link.href} role="none">
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      role="menuitem"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>

        <a
          className="nav-btn nav-btn--login"
          href="https://sandbox.bayun.dev/dev-portal/login"
          target="_blank"
          rel="noopener noreferrer"
        >
          Login
        </a>
      </div>
    </nav>
  );
};

export default Nav;
